import React from 'react';
import { PageHero } from '../components/PageHero';
import { Button } from '../components/ui/Button';
import { Mail, MapPin, Calendar, Clock } from 'lucide-react';
import { BOOKING_URL } from '../lib/navigation';
export function GetStarted() {
  return <div className="animate-fade-in-up" data-id="element-344">
      <PageHero title="Get Started" subtitle="Take the first step towards a life that feels like yours." data-id="element-345" />

      <section className="py-20 bg-white" data-id="element-346">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-347">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-348">
            {/* Left Column: Info */}
            <div data-id="element-349">
              <h2 className="text-3xl font-medium text-teal mb-8" data-id="element-350">
                Ready to talk?
              </h2>
              <p className="text-lg text-teal/80 mb-12" data-id="element-351">
                The best way to see if we're a good fit is to hop on a quick
                video call. It's free, low-pressure, and gives you a chance to
                ask any questions you have.
              </p>

              <div className="space-y-8 mb-12" data-id="element-352">
                <div className="flex items-start" data-id="element-353">
                  <div className="w-12 h-12 bg-sage/10 rounded-full flex items-center justify-center mr-4 flex-shrink-0 text-sage" data-id="element-354">
                    <Calendar className="w-6 h-6" data-id="element-355" />
                  </div>
                  <div data-id="element-356">
                    <h3 className="font-medium text-teal text-lg mb-1" data-id="element-357">
                      Free Consultation
                    </h3>
                    <p className="text-teal/70" data-id="element-358">
                      15-minute video call to discuss your needs and goals.
                    </p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-359">
                  <div className="w-12 h-12 bg-terracotta/10 rounded-full flex items-center justify-center mr-4 flex-shrink-0 text-terracotta" data-id="element-360">
                    <Clock className="w-6 h-6" data-id="element-361" />
                  </div>
                  <div data-id="element-362">
                    <h3 className="font-medium text-teal text-lg mb-1" data-id="element-363">
                      Session Availability
                    </h3>
                    <p className="text-teal/70" data-id="element-364">
                      Flexible weekday and evening appointments available.
                    </p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-365">
                  <div className="w-12 h-12 bg-teal/10 rounded-full flex items-center justify-center mr-4 flex-shrink-0 text-teal" data-id="element-366">
                    <MapPin className="w-6 h-6" data-id="element-367" />
                  </div>
                  <div data-id="element-368">
                    <h3 className="font-medium text-teal text-lg mb-1" data-id="element-369">
                      Location
                    </h3>
                    <p className="text-teal/70" data-id="element-370">
                      Secure online video therapy available across all of
                      Ontario.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-neutral-soft p-8 rounded-2xl border border-sage/20" data-id="element-371">
                <h3 className="font-medium text-teal mb-4" data-id="element-372">Contact</h3>
                <a href="mailto:jess@arrivetherapy.ca" className="flex items-center text-teal/80 hover:text-terracotta transition-colors" data-id="element-373">
                  <Mail className="w-5 h-5 mr-3" data-id="element-374" />
                  jess@arrivetherapy.ca
                </a>
              </div>
            </div>

            {/* Right Column: Simple Booking CTA */}
            <div className="flex items-start" data-id="element-375">
              <div className="bg-white rounded-3xl shadow-xl border border-neutral-100 p-8 md:p-10 w-full text-center" data-id="element-376">
                <div className="w-20 h-20 bg-sage/10 rounded-full flex items-center justify-center mx-auto mb-8" data-id="element-377">
                  <Calendar className="w-10 h-10 text-sage" data-id="element-378" />
                </div>

                <h3 className="text-2xl font-medium text-teal mb-4" data-id="element-379">
                  Book Your Session
                </h3>
                <p className="text-teal/70 mb-4 max-w-sm mx-auto" data-id="element-380">
                  Schedule a free 15-minute video consultation to see if we're a
                  good fit. No pressure, no commitment, just a conversation.
                </p>
                <p className="text-teal/70 mb-8 text-sm max-w-sm mx-auto" data-id="element-381">
                  Already know you're ready? You can also go ahead and book your
                  first full session directly.
                </p>

                <Button className="w-full" size="lg" onClick={() => window.open(BOOKING_URL, '_blank')} data-id="element-382">
                  Book Now
                </Button>

                <div className="mt-8 pt-6 border-t border-neutral-100" data-id="element-383">
                  <p className="text-sm text-teal/60" data-id="element-384">
                    Have questions or need help booking? Email me at{' '}
                    <a href="mailto:jess@arrivetherapy.ca" className="text-terracotta hover:underline" data-id="element-385">
                      jess@arrivetherapy.ca
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
}